import React from 'react';

import Loader from './CustomLoader';
import withTranslation from './withTranslation';

const FileLoading = ({ translateString }) => (
  <div style={{ display: 'flex', marginTop: '1rem', alignItems: 'center' }}>
    <h4 style={{ paddingRight: 20, textDecoration: 'underline' }}>
      {`${translateString('Please wait while your file is uploading')}...`}
    </h4>
    <Loader />
  </div>
);

export default withTranslation(FileLoading);
